import { Modal } from "antd";
import styled from "styled-components";
export const Content = styled(Modal)`
.ant-modal-content{
  border-radius: 8px;

}
.ant-modal-header{
  border-radius: 8px;

}
.ant-modal-body{
  min-height: 300px;
}
 .ant-modal-title {
    color: ${({ theme }) => theme.colors.secondary100};
    font-size: 18px;
    font-weight: 500;
    align-self: flex-start;
  }
  .actions{
    width: '100%';
    display: flex;
    align-items: center;
    justify-content: end;
    align-self: flex-end;
    gap: 15px;
  }
  .modal-content{
    min-height: 400px;
  }
`;
